import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-dark-bg">
      <Navbar />
      <main>
        <section className="pt-28 md:pt-36 pb-12 md:pb-16 bg-dark-bg">
          <div className="w-full px-6 md:px-10 lg:px-16 max-w-4xl">
            <p className="text-xs md:text-sm font-sans font-semibold tracking-[0.2em] text-gold uppercase mb-4">
              Legal
            </p>
            <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-medium text-charcoal-50 leading-tight tracking-tight-xl mb-6">
              Privacy Policy
            </h1>
            <p className="text-base md:text-lg text-charcoal-300 font-sans leading-relaxed max-w-2xl">
              This Privacy Policy explains how Propre Purification collects, uses, and protects your personal information when you visit our website or submit inquiries through our forms.
            </p>
          </div>
        </section>

        <section className="pb-24 md:pb-32 bg-dark-bg">
          <div className="w-full px-6 md:px-10 lg:px-16 max-w-4xl">
            <div className="flex flex-col gap-12 md:gap-16">
              <div>
                <h2 className="font-serif text-xl md:text-2xl font-semibold text-charcoal-50 mb-4">
                  Information We Collect
                </h2>
                <p className="text-base text-charcoal-300 font-sans leading-relaxed mb-4">
                  When you submit a form on our website, we collect the information you voluntarily provide, which may include your name, email address, phone number, city, and any messages or package interests you share with us.
                </p>
                <p className="text-base text-charcoal-300 font-sans leading-relaxed">
                  We do not collect sensitive personal information such as social security numbers, financial data, or health records through this website.
                </p>
              </div>

              <div>
                <h2 className="font-serif text-xl md:text-2xl font-semibold text-charcoal-50 mb-4">
                  How We Use Your Information
                </h2>
                <p className="text-base text-charcoal-300 font-sans leading-relaxed mb-4">
                  The information you provide is used solely to respond to your inquiries, schedule consultations, and recommend appropriate water filtration systems for your home. We may contact you via email or phone to discuss your water quality needs and provide quotes.
                </p>
                <p className="text-base text-charcoal-300 font-sans leading-relaxed">
                  We do not sell, rent, or share your personal information with third parties for marketing purposes. Your information is only shared with our internal team members who are directly involved in serving your request.
                </p>
              </div>

              <div>
                <h2 className="font-serif text-xl md:text-2xl font-semibold text-charcoal-50 mb-4">
                  Data Storage and Security
                </h2>
                <p className="text-base text-charcoal-300 font-sans leading-relaxed mb-4">
                  Form submissions are transmitted securely and stored in our customer relationship management systems. We take reasonable precautions to protect your information from unauthorized access, disclosure, or misuse.
                </p>
                <p className="text-base text-charcoal-300 font-sans leading-relaxed">
                  While we strive to use commercially acceptable means to protect your personal information, no method of transmission over the internet or electronic storage is 100% secure.
                </p>
              </div>

              <div>
                <h2 className="font-serif text-xl md:text-2xl font-semibold text-charcoal-50 mb-4">
                  Cookies and Tracking
                </h2>
                <p className="text-base text-charcoal-300 font-sans leading-relaxed">
                  Our website may use basic analytics and functional cookies to improve user experience. These do not collect personally identifiable information and are used only to understand general visitor behavior and site performance.
                </p>
              </div>

              <div>
                <h2 className="font-serif text-xl md:text-2xl font-semibold text-charcoal-50 mb-4">
                  Your Rights
                </h2>
                <p className="text-base text-charcoal-300 font-sans leading-relaxed mb-4">
                  You have the right to request access to the personal information we hold about you, request corrections to inaccurate information, or request that we delete your information from our records.
                </p>
                <p className="text-base text-charcoal-300 font-sans leading-relaxed">
                  To exercise any of these rights, please contact us at info@proprepurification.com or call (515) 207-0355.
                </p>
              </div>

              <div>
                <h2 className="font-serif text-xl md:text-2xl font-semibold text-charcoal-50 mb-4">
                  Changes to This Policy
                </h2>
                <p className="text-base text-charcoal-300 font-sans leading-relaxed">
                  We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. Any updates will be posted on this page with a revised effective date. We encourage you to review this policy periodically.
                </p>
              </div>

              <div>
                <h2 className="font-serif text-xl md:text-2xl font-semibold text-charcoal-50 mb-4">
                  Contact Us
                </h2>
                <p className="text-base text-charcoal-300 font-sans leading-relaxed">
                  If you have any questions about this Privacy Policy or how we handle your information, please reach out to us at info@proprepurification.com or by phone at (515) 207-0355.
                </p>
              </div>

              <div className="border-t border-dark-border pt-8">
                <p className="text-sm text-charcoal-400 font-sans">
                  Last updated: May 18, 2026
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}